<div class="form-card form-card-large" [formGroup]="form">
  <h2 class="form-title">
    <span class="icon"> </span>
    Choisissez une carte
  </h2>
  <div class="form-group">
    <div class="form-row selector-row">
      <!-- Premium -->
      @if (withPremium) {
        <div class="casto-selector card-selector">
          <input type="radio" name="cardIsPremium" id="premium" formControlName="cardIsPremium" [value]="true" />
          <label for="premium">
            <div class="card-visuel">
              <svg>
                <use xlink:href="assets/img/icons.svg#ccastomax"></use>
              </svg>
              <span
                class="price"
                [innerHtml]="'fidelity-card.price-label' | translate: { price: premiumCardPrice }"></span>
            </div>
            <p class="card-name" [innerHtml]="'fidelity-card.premium-card-name' | translate"></p>
            <p [innerHtml]="'fidelity-card.premium-card-description' | translate"></p>
          </label>
        </div>
      }

      @if (withFree) {
        <!-- Free -->
        <div class="casto-selector card-selector">
          <input
            type="radio"
            name="cardIsPremium"
            id="free"
            formControlName="cardIsPremium"
            [value]="false"
            [disabled]="!withPremium"
            checked="checked" />
          <label for="free">
            <div class="card-visuel">
              <svg>
                <use xlink:href="assets/img/icons.svg#ccasto"></use>
              </svg>
              <span class="price" [innerHtml]="'fidelity-card.free-label' | translate"></span>
            </div>
            <p class="card-name" [innerHtml]="'fidelity-card.free-card-name' | translate"></p>
            <p [innerHtml]="'fidelity-card.free-card-description' | translate"></p>
          </label>
        </div>
      }
    </div>
  </div>
</div>
